import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface SectionCardProps {
  children: ReactNode;
  className?: string;
}

export function SectionCard({ children, className }: SectionCardProps) {
  return (
    <section
      className={cn(
        "rounded-xl border border-[var(--border-subtle)] bg-[var(--bg-surface-primary)] p-4 shadow-[var(--shadow-popout)] sm:p-6",
        className
      )}
    >
      {children}
    </section>
  );
}
